
module.directive('similarStudents', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/similarStudents',
        scope: {programId: '=', name: '='},
        link: function(scope, element, attrs) {
            var getSimilar = ModelService.getRelation.bind(
                ModelService, 'program', scope.programId, 'similar-participants')

            scope.$watch('name', function(name) {
                getSimilar({name: name}).then(function(similar) {
                    scope.similar = similar;
                });
            });
        }
    };
});